"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputButtonManager = void 0;
const react_1 = __importDefault(require("react"));
const InputFloatButtons_1 = require("../Util/InputFloatButtons");
const Button_1 = __importDefault(require("../Util/Button"));
const InputButtonManager = ({ buttons, help, onReset, value }) => {
    const showResetButton = onReset && value.length > 0;
    const hasButtons = showResetButton || !!buttons || help;
    if (!hasButtons) {
        return null;
    }
    return (react_1.default.createElement(InputFloatButtons_1.InputFloatButtons, null,
        showResetButton && (react_1.default.createElement(Button_1.default, { className: "j-input-reset-button size-sm", onClick: onReset }, "X")),
        help && (react_1.default.createElement(Button_1.default, { className: "size-sm border-primary border-2 rounded-full w-6 h-6 min-w-0 justify-center", tooltip: help }, "?")),
        buttons));
};
exports.InputButtonManager = InputButtonManager;
